//@ts-nocheck
import { Fragment, useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "react-feather";
import ConfigDB from "../../Config/Theme-Config";
import SidebarMenuItems from "./SidebarMenuItems";
import SidebarSection from "./SidebarSection";
import { CSS } from "src/_utils/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Label } from "reactstrap";
import { Session } from "src/base/store/authSlice";
import { Layout } from "src/base/store/layoutSlice";
import { ReduxDataKey } from "src/base/store/store";
import { LI, UL } from "../../AbstractElements";
import { Back } from "../../Constant";

const SidebarMenuItemsFull = ({ setMainMenu, sidebartoogle, setNavActive }) => {
  // eslint-disable-next-line
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);

  const [active, setActive] = useState(false);
  const { t } = useTranslation();
  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className = "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon ";
      if (item.type === "sub") {
        document.querySelector(".page-header").className = "page-header ";
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      }
    }
    if (!item.active) {
      ebsssLayout?.menu?.map((a) => {
        a.Items.filter((Items) => {
          if (a.Items?.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items?.children?.forEach((b) => {
            if (Items?.children?.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b?.children?.forEach((c) => {
              if (b?.children?.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    if (item.children) {
      item.active = !item.active;
    }
    setMainMenu({
      mainmenu: ebsssLayout?.menu ? ebsssLayout?.menu : [],
    });
  };

  return (
    <Fragment>
      <UL
        attrUL={{
          className: "custom-scrollbar simple-list sidebar-links mt-1",
          id: "simple-bar",
        }}
      >
        <div className="simplebar-wrapper" style={{ margin: "0px" }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div className="simplebar-offset" style={{ right: "0px", bottom: "0px" }}>
              <div className="simplebar-content-wrapper" style={{ height: "100%" }}>
                <div className="simplebar-content">
                  <LI attrLI={{ className: "back-btn" }}>
                    <div className="mobile-back text-end">
                      <span>{Back}</span>
                      <i className="fa fa-angle-right ps-2"></i>
                    </div>
                  </LI>
                  {ebsssLayout?.menu?.map((Item, i) => (
                    <Fragment key={i}>
                      {Item.Items.map((menuItem, i) => (
                        <LI attrLI={{ className: "sidebar-list" }} key={i}>
                          {menuItem.type === "sub" && (
                            <Fragment>
                              {Item?.count && Item?.count > 0 ? (
                                <div className="col-2">
                                  <Label className="badge badge-light-primary">{Item?.count} </Label>
                                </div>
                              ) : (
                                <></>
                              )}
                              {menuItem.badge1 && <Label className="badge badge-light-info">New </Label>}
                              {menuItem.children.length === 0 ? (
                                <Link
                                  to={Item.path}
                                  className={`d-flex justify-items-between align-items-center sidebar-link sidebar-title ${
                                    menuItem.active || active ? " active" : ""
                                  }`}
                                >
                                  {Item.icon ? <i className={`${Item.icon} text-secondary fs-5 me-2`}></i> : <></>}
                                  <span
                                    className="col-8"
                                    style={CSS({
                                      wordBreak: "break-word",
                                    })}
                                  >
                                    {t(menuItem.title)}
                                  </span>
                                  {menuItem.children.length > 0 ? (
                                    <div className="according-menu">
                                      {menuItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </Link>
                              ) : (
                                <a
                                  href="javascript"
                                  className={`d-flex justify-items-between align-items-center sidebar-link sidebar-title ${
                                    menuItem.active || active ? " active" : ""
                                  }`}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    return menuItem.children.length > 0 ? setNavActive(menuItem) : () => {};
                                  }}
                                >
                                  {Item.icon ? <i className={`${Item.icon} text-secondary fs-5 me-2`}></i> : <></>}
                                  <span
                                    className="col-8"
                                    style={CSS({
                                      wordBreak: "break-word",
                                    })}
                                  >
                                    {t(menuItem.title)}
                                  </span>
                                  {menuItem.children.length > 0 ? (
                                    <div className="according-menu">
                                      {menuItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </a>
                              )}
                            </Fragment>
                          )}
                          {menuItem.type === "link" && (
                            <>
                              {menuItem.badge2 && <Label className="badge badge-light-danger">Latest</Label>}
                              <Link
                                to={menuItem.path}
                                className={`sidebar-link sidebar-title ${menuItem.active ? "active" : ""}`}
                                onClick={() => toggletNavActive(menuItem)}
                              >
                                {Item.icon ? <i className={`${Item.icon} text-secondary fs-5 me-2`}></i> : <></>}
                                <span>{t(menuItem.title)}</span>
                              </Link>
                            </>
                          )}
                          {menuItem.children && (
                            <UL
                              attrUL={{
                                className: "simple-list sidebar-submenu",
                                style: menuItem.active
                                  ? sidebartoogle
                                    ? {
                                        opacity: 1,
                                        transition: "opacity 500ms ease-in",
                                      }
                                    : { display: "block" }
                                  : { display: "none" },
                              }}
                            >
                              {menuItem?.children?.map((childrenItem, index) => {
                                return (
                                  <LI key={index}>
                                    {childrenItem.type === "sub" && (
                                      <a
                                        href="javascript"
                                        className={`${childrenItem.active ? "active" : ""}`}
                                        onClick={(event) => {
                                          event.preventDefault();
                                          toggletNavActive(childrenItem);
                                        }}
                                      >
                                        {t(childrenItem.title)}
                                        <div className="according-menu">
                                          {childrenItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}{" "}
                                        </div>
                                      </a>
                                    )}
                                    {childrenItem.type === "link" && (
                                      <Link
                                        to={childrenItem.path}
                                        className={`${childrenItem.active ? "active" : ""}`}
                                        onClick={() => toggletNavActive(childrenItem)}
                                      >
                                        {t(childrenItem.title)}
                                      </Link>
                                    )}
                                    {childrenItem.children && (
                                      <UL
                                        attrUL={{
                                          className: "simple-list nav-sub-childmenu submenu-content",
                                          style: childrenItem.active ? { display: "block" } : { display: "none" },
                                        }}
                                      >
                                        {childrenItem?.children?.map((childrenSubItem, key) => (
                                          <LI key={key}>
                                            {childrenSubItem.type === "link" && (
                                              <Link
                                                to={childrenSubItem.path}
                                                className={`${childrenSubItem.active ? "active" : ""}`}
                                                onClick={() => toggletNavActive(childrenSubItem)}
                                              >
                                                {t(childrenSubItem.title)}
                                              </Link>
                                            )}
                                          </LI>
                                        ))}
                                      </UL>
                                    )}
                                  </LI>
                                );
                              })}
                            </UL>
                          )}
                        </LI>
                      ))}
                    </Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="simplebar-track simplebar-horizontal" style={{ visibility: "hidden" }}>
          <div className="simplebar-scrollbar" style={{ width: "0px", display: "none" }}></div>
        </div>
        <div className="simplebar-track simplebar-vertical" style={{ visibility: "visible" }}>
          <div className="simplebar-scrollbar"></div>
        </div>
      </UL>
    </Fragment>
  );
};

const SidebarMenu = ({ setMainMenu, props, sidebartoogle, setNavActive, compactMenu, width }) => {
  const [rightArrow, setRightArrow] = useState(false);
  const [leftArrow, setLeftArrow] = useState(false);
  const sidebar_types = localStorage.getItem("sidebar_types");
  const wrapper = sidebar_types || ConfigDB.data.settings.sidebar.type;
  const [margin, setMargin] = useState(0);
  const [pressingLeftArrow, setPressingLeftArrow] = useState(false);
  const [pressingRightArrow, setPressingRightArrow] = useState(false);
  const [scrollIntervalLeft, setScrollIntervalLeft] = useState(null);
  const [scrollIntervalRight, setScrollIntervalRight] = useState(null);

  const scrollLeft = () => {
    const content = document.querySelector(".simplebar-content");
    if (content) {
      content.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    const content = document.querySelector(".simplebar-content");
    if (content) {
      content.scrollBy({ left: 150, behavior: "smooth" });
    }
  };

  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      if (width === 492) {
        setMargin(-3570);
      } else {
        setMargin(-3464);
      }
      setRightArrow(true);
      setLeftArrow(false);
    } else {
      setLeftArrow(false);
      setMargin((margin) => (margin += -width));
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setLeftArrow(true);
      setRightArrow(false);
    } else {
      setMargin((margin) => (margin += width));
      setRightArrow(false);
    }
  };

  useEffect(() => {
    if (pressingLeftArrow && !scrollIntervalLeft) {
      const interval = setInterval(scrollLeft, 16);
      setScrollIntervalLeft(interval);
    } else if (!pressingLeftArrow && scrollIntervalLeft) {
      clearInterval(scrollIntervalLeft);
      setScrollIntervalLeft(null);
    }

    if (pressingRightArrow && !scrollIntervalRight) {
      const interval = setInterval(scrollRight, 16);
      setScrollIntervalRight(interval);
    } else if (!pressingRightArrow && scrollIntervalRight) {
      clearInterval(scrollIntervalRight);
      setScrollIntervalRight(null);
    }

    // Cleanup intervals when the component unmounts
    return () => {
      if (scrollIntervalLeft) clearInterval(scrollIntervalLeft);
      if (scrollIntervalRight) clearInterval(scrollIntervalRight);
    };
  }, [pressingLeftArrow, pressingRightArrow, scrollIntervalLeft, scrollIntervalRight]);

  return localStorage.getItem("sidebar_types") !== "compact-wrapper" || props.horizontalMenu ? (
    <Fragment>
      <nav className="sidebar-main no-print-ebsss">
        <div
          className="left-arrow left-arrow-menu d-block"
          onTouchStart={() => setPressingLeftArrow(true)}
          onTouchEnd={() => setPressingLeftArrow(false)}
          onTouchCancel={() => setPressingLeftArrow(false)}
          onMouseDown={() => setPressingLeftArrow(true)}
          onMouseUp={() => setPressingLeftArrow(false)}
          onMouseLeave={() => setPressingLeftArrow(false)}
        >
          <ArrowLeft />
        </div>
        <div id="sidebar-menu" style={wrapper.split(" ")?.includes("horizontal-wrapper") ? { marginLeft: margin + "px" } : { margin: "0px" }}>
          <SidebarMenuItems
            setMainMenu={setMainMenu}
            props={props}
            sidebartoogle={sidebartoogle}
            setNavActive={setNavActive}
            scrollLeft={scrollLeft}
            scrollRight={scrollRight}
          />
          <SidebarSection />
        </div>
        <div
          className="right-arrow"
          onTouchStart={() => setPressingRightArrow(true)}
          onTouchEnd={() => setPressingRightArrow(false)}
          onTouchCancel={() => setPressingRightArrow(false)}
          onMouseDown={() => setPressingRightArrow(true)}
          onMouseUp={() => setPressingRightArrow(false)}
          onMouseLeave={() => setPressingRightArrow(false)}
          style={{ right: -5 }}
        >
          <ArrowRight />
        </div>
      </nav>
    </Fragment>
  ) : (
    <Fragment>
      <nav className="sidebar-main no-print-ebsss">
        <div className={`left-arrow ${leftArrow ? "d-none" : ""}`} id="left-arrow" onClick={scrollToLeft}>
          <ArrowLeft />
        </div>
        <div id="sidebar-menu" style={wrapper.split(" ")?.includes("horizontal-wrapper") ? { marginLeft: margin + "px" } : { margin: "0px" }}>
          <SidebarMenuItemsFull setMainMenu={setMainMenu} props={props} sidebartoogle={sidebartoogle} setNavActive={setNavActive} />
          <SidebarSection />
        </div>
        <div className={`right-arrow ${rightArrow ? "d-none" : ""}`} onClick={scrollToRight}>
          <ArrowRight />
        </div>
      </nav>
    </Fragment>
  );
};

export default SidebarMenu;
